/**
 * @generated SignedSource<<a9b61d3d40bac8ebec0f64586e8353fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RevenueRecognitionPage_company$data = {
  readonly id: string;
  readonly currency: string | null;
  readonly " $fragmentType": "RevenueRecognitionPage_company";
};
export type RevenueRecognitionPage_company$key = {
  readonly " $data"?: RevenueRecognitionPage_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"RevenueRecognitionPage_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RevenueRecognitionPage_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "0ac70c35a565cad5ff2ee074fc3dfe21";

export default node;
